import React, { Component, PropTypes } from 'react'

export class BiColumn__about extends Component {
  render() {
    return (
      <section>
        <div className="container">
          <div className="section__body">
            <div className="row">
              <div className="column--third">
                <div className="section__head--leftAlign">
                  <h5>PlayVS is bringing esports to high schools across North America.</h5>
                </div>
              </div>
              <div className="column--twoThird">
                <div className="section__head--leftAlign noMaxWidth">
                  <p className="lead">Through our online platform, integrations with game publishers, and exclusive partnership with the NFHS, we are building the infrastructure for the next big emerging sport. This marks the first time that students will compete in esports on behalf of their high school, with the opportunity to win an official state championship, just like any other youth sport. </p>
                </div>
              </div>
              
            </div>
          </div>
        </div>
      </section>
    )
  }
}

export default BiColumn__about


// WEBPACK FOOTER //
// ./src/common/ui/components/biColumn__about.js